import { createSelector } from "reselect";
import { getAllSureMotorClaim } from "./index";

export const getIncidentDetails = createSelector(
    getAllSureMotorClaim,
    (allSureMotorClaim) => allSureMotorClaim.incidentDetails
);
export const getIncidentDetailsForm = createSelector(
    getIncidentDetails,
    (incidentDetails) => incidentDetails.form
);


